import {Action} from 'redux'
import {
  FULFILL_CANDLES_DATA,
  FULFILL_EXPIRED_SIGNALS,
  FULFILL_SIGNAL,
  FULFILL_SIGNALS,
  FULFILL_SIMPLE_SIGNALS, FULFILL_TELEGRAM_SIGNALS,
} from '../constants'
import {CandlesData, SimpleSignal, TelegramSignalsResponse} from '../types'
import {ExpiredSignals, Signal, Signals} from '@bdswiss/mt4-connector'

export interface FulfillSignals extends Action {
  type: FULFILL_SIGNALS
  signals: Signals
}

export function fulfillSignals(signals: Signals): FulfillSignals {
  return {
    type: FULFILL_SIGNALS,
    signals,
  }
}

export interface FulfillCandlesData extends Action {
  type: FULFILL_CANDLES_DATA
  candlesData: CandlesData
}

export function fulfillCandlesData(candlesData: CandlesData): FulfillCandlesData {
  return {
    type: FULFILL_CANDLES_DATA,
    candlesData,
  }
}

export interface FulfillSignal extends Action {
  type: FULFILL_SIGNAL
  signal: Signal
}

export function fulfillSignal(signal: Signal): FulfillSignal {
  return {
    type: FULFILL_SIGNAL,
    signal,
  }
}

export interface FulfillExpiredSignals extends Action {
  type: FULFILL_EXPIRED_SIGNALS
  expiredSignals: ExpiredSignals
}

export function fulfillExpiredSignals(expiredSignals: ExpiredSignals): FulfillExpiredSignals {
  return {
    type: FULFILL_EXPIRED_SIGNALS,
    expiredSignals,
  }
}

export interface FulfillSimpleSignals extends Action {
  type: FULFILL_SIMPLE_SIGNALS,
  signals: SimpleSignal[]
}

export function fulfillSimpleTradingSignals(signals: SimpleSignal[]): FulfillSimpleSignals {
  return {
    type: FULFILL_SIMPLE_SIGNALS,
    signals
  }
}

export interface FulfillTelegramSignals extends Action {
  type: FULFILL_TELEGRAM_SIGNALS,
  signals: TelegramSignalsResponse
}

export function fulfillTelegramSignals(signals: TelegramSignalsResponse): FulfillTelegramSignals {
  // console.log(signals)
  return {
    type: FULFILL_TELEGRAM_SIGNALS,
    signals
  }
}
